module.exports = __webpack_public_path__ + "static/media/20ECE22.632c6156.jpg";